import { render, staticRenderFns } from "./productCategoryTree.vue?vue&type=template&id=44e49766&scoped=true&"
import script from "./productCategoryTree.vue?vue&type=script&lang=babel&"
export * from "./productCategoryTree.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e49766",
  null
  
)

export default component.exports